
export interface GlobalTab {
	id: number;
	title: string;
	entity: HeaderTabEntities;
}

export enum HeaderTabEntities {
	TICKETS = "TICKETS",
	USERS = "USERS"
}

export function getGlobalTabUrlPath(tab: GlobalTab) {
	switch (tab.entity) {
		case HeaderTabEntities.TICKETS:
			return "/tickets/" + tab.id;
		case HeaderTabEntities.USERS:
			return "/users/" + tab.id;
	}
}
